import { bankingService } from '@afterpaytouch/portal-api/consumer/bankingSessions'

export const { useCreateBankingSessionMutation, useGetBankingSessionLatestQuery, useUpdateBankingSessionsMutation } = bankingService
